import React, { useState } from 'react';
import DocumentListing from './components/DocumentListing';
import { deleteDocument } from '../../utils/Api';

const DocumentList = ({ documentList, setDocumentList, selectable = true }) => {
    const [selectedImages, setSelectedImages] = useState({});

    const handleSelect = (id) => {
        setSelectedImages((prev) => {
            const updated = {
                ...prev,
                [id]: !prev[id]
            };
            return updated;
        });
    };

    const handleDownload = async (id) => {
        try {
            //const { status, data } = await getJobData(id);
            const status = 206;
            const data = {};
            if (status === 206) {
                console.info("Results not ready...")
            }
            else {
                const blob = new Blob([JSON.stringify(data.readable_data, null, 2)], { type: "application/json" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `job_${id}.json`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error('Download error:', err);
        }
    }

    const handleDelete = async (id) => {
        try {
            const response = await deleteDocument(id);
            setDocumentList((prev) => {
                const updatedList = { ...prev };
                delete updatedList[id];
                return updatedList;
            });
        } catch (error) {
            console.error('Delete error:', error)
        }
    }

    return (
        <ul className="flex-grow overflow-y-auto flex flex-col gap-3 no-scrollbar p-2 min-h-70">
            {Object.entries(documentList).map(([id, { thumbnail, name, created_at }]) => (
                <DocumentListing
                    key={id}
                    id={id}
                    thumbnail={thumbnail}
                    isChecked={!!selectedImages[id]}
                    onSelect={handleSelect}
                    onDownload={handleDownload}
                    onDelete={handleDelete}
                    created_at={created_at}
                    name={name}
                    selectable={selectable}
                />
            ))}
        </ul>
    );
};

export default DocumentList;